export default "__VITE_ASSET__ROy6N5he__"